import { readInstallAttribution } from './installAttribution';

// Same-origin, no cookies/SDK/device registration. Navigation never waits for this.
export function trackInstallEvent(event, search = '', store) {
    if (!['install_landing_view', 'install_store_click'].includes(event)) return Promise.resolve();
    if (event === 'install_store_click' && !['ios', 'android'].includes(store)) return Promise.resolve();
    const { source, medium, campaign } = readInstallAttribution(search);
    const payload = { event, source, medium, campaign };
    if (event === 'install_store_click') payload.store = store;
    try {
        return Promise.resolve(fetch('/install-events', {
            method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer', keepalive: true,
            headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
        })).then(() => {}).catch(() => {});
    } catch (_) { return Promise.resolve(); }
}
